/**
 * 의약품 정보 게시 일시 선택 — 레거시 `DrugInfoPublishScheduleModal.js` 포팅
 */
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import { Input } from '@/shared/components/ui/input';
import { Label } from '@/shared/components/ui/label';
import React, { useEffect, useState } from 'react';

interface DrugInfoPublishScheduleModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (scheduledAt: string, immediate: boolean) => void;
}

export const DrugInfoPublishScheduleModal: React.FC<
  DrugInfoPublishScheduleModalProps
> = ({ open, onClose, onConfirm }) => {
  const defaultValue = () => {
    const d = new Date();
    d.setMinutes(d.getMinutes() + 30);
    return d.toISOString().slice(0, 16);
  };

  const [publishAt, setPublishAt] = useState(defaultValue);
  const [immediate, setImmediate] = useState(false);

  useEffect(() => {
    if (open) {
      setPublishAt(defaultValue());
      setImmediate(false);
    }
  }, [open]);

  const handleConfirm = () => {
    const when = immediate ? new Date().toISOString() : new Date(publishAt).toISOString();
    onConfirm(when, immediate);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>의약품 데이터 공개 일시</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <input
              id="immediate"
              type="checkbox"
              checked={immediate}
              onChange={(e) => setImmediate(e.target.checked)}
            />
            <Label htmlFor="immediate">즉시 공개</Label>
          </div>
          {!immediate && (
            <div className="space-y-1">
              <Label>공개 일시</Label>
              <Input
                type="datetime-local"
                value={publishAt}
                onChange={(e) => setPublishAt(e.target.value)}
              />
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            취소
          </Button>
          <Button onClick={handleConfirm}>확인</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
